(() => {
  'use strict';

  const BASE_CURRENCY = 'USD';
  const CACHE_KEY = 'currency_rates_cache_v7';
  const CACHE_TTL = 12 * 60 * 60 * 1000;
  const DECIMALS = { KWD:3, BHD:3, OMR:3, USD:0, AED:2, QAR:2, SAR:2 };
  const FLAG_FALLBACK = 'https://cdn.shopify.com/s/files/1/0737/2069/3009/files/USD.png?v=1763453689';

  const CUSTOM_SYMBOLS = { KWD:'KD', BHD:'BD', OMR:'OMR', QAR:'QAR', SAR:'SAR', AED:'AED', USD:'$' };

  // Set true for currencies that must display as whole integers (rounded UP)
  // Example: { KWD: true } will show 22.01 => 23 KD
  const ROUNDED = { KWD: true, BHD: true, OMR: true, QAR: true, SAR: true, AED: true }; 

  const providers = [
    async (valid) => {
      try {
        const r = await fetch('https://open.er-api.com/v6/latest/' + encodeURIComponent(BASE_CURRENCY), { cache: 'no-cache' });
        if (!r.ok) throw r.status;
        const b = await r.json();
        if (!b?.rates) throw 'no';
        const subset = {};
        valid.forEach(k => { if (b.rates[k]) subset[k] = b.rates[k]; });
        return { rates: subset };
      } catch (e) { return null; }
    },
    async (valid) => {
      try {
        const qs = `?base=${encodeURIComponent(BASE_CURRENCY)}&symbols=${valid.join(',')}`;
        const r = await fetch('https://api.exchangerate.host/latest' + qs, { cache: 'no-cache' });
        if (!r.ok) throw r.status;
        const b = await r.json();
        if (!b?.rates) throw 'no';
        return { rates: b.rates };
      } catch (e) { return null; }
    }
  ];

  window.currencySwitcher = window.currencySwitcher || {};
  if (window.currencySwitcher._initialized) return;
  window.currencySwitcher._initialized = true;
  window.currencySwitcher._ready = false;
  window.currencySwitcher._cachedRates = window.currencySwitcher._cachedRates || null;
  window.currencySwitcher._lastCurrency = window.currencySwitcher._lastCurrency || null;
  window.currencySwitcher._lastRate = window.currencySwitcher._lastRate || null;

  function normalizeCode(c) { if (!c) return c; c = String(c).trim().toUpperCase(); if (c === 'KSA') return 'SAR'; return c; }
  function isIso(c) { return /^[A-Z]{3}$/.test(c); }

  // function parsePriceTextToCents(text) {
  //   if (!text) return 0;
  //   let seenDecimal = false, intPart = '', decPart = '';
  //   for (let i = 0; i < text.length; i++) {
  //     const ch = text[i], n = ch.charCodeAt(0) - 48;
  //     if (n >= 0 && n <= 9) { if (!seenDecimal) intPart += ch; else if (decPart.length < 3) decPart += ch; }
  //     else if (!seenDecimal && (ch === '.' || ch === ',')) seenDecimal = true;
  //   }
  //   if (!intPart) intPart = '0';
  //   let integer = 0;
  //   for (let i = 0; i < intPart.length; i++) integer = integer * 10 + (intPart.charCodeAt(i) - 48);
  //   let cents = 0;
  //   if (decPart.length === 0) cents = 0;
  //   else if (decPart.length === 1) cents = (decPart.charCodeAt(0) - 48) * 10;
  //   else cents = (decPart.charCodeAt(0) - 48) * 10 + (decPart.charCodeAt(1) - 48);
  //   return integer * 100 + cents;
  // }

function parsePriceTextToCents(text) {
  if (!text) return 0;
  text = String(text).trim();
  text = text.replace(/[\u00A0\u202F\u2009\u2007\u2008]/g, '');
  text = text.replace(/[^\d\.,'\-]/g, '');
  const lastDot = text.lastIndexOf('.');
  const lastComma = text.lastIndexOf(',');
  let decimalSep = null;
  if (lastDot > -1 && lastComma > -1) decimalSep = (lastDot > lastComma ? '.' : ',');
  else if (lastDot > -1) decimalSep = '.';
  else if (lastComma > -1) {
    const after = text.slice(lastComma + 1);
    if (/^\d{1,2}$/.test(after)) decimalSep = ',';
    else decimalSep = null;
  }

  if (decimalSep) {
    const parts = text.split(decimalSep);
    const intPart = (parts[0] || '').replace(/[^\d]/g, '') || '0';
    const decRaw = (parts[1] || '').replace(/[^\d]/g, '');
    const dec = decRaw.slice(0, 2);
    const integer = parseInt(intPart, 10) || 0;
    const cents = dec.length === 0 ? 0 : (dec.length === 1 ? (parseInt(dec, 10) * 10) : parseInt(dec, 10));
    return integer * 100 + cents;
  } else {
    const digits = text.replace(/[^\d]/g, '') || '0';
    const integer = parseInt(digits, 10) || 0;
    return integer * 100;
  }
}



  function annotateMoney(root = document) {
    const sels = ['.money', 'price-list .money', 'sale-price .money', '.product-info__block-item .money', '.price-list .money', '.product-card .money', '.product-card__price .money'];
    const nodes = new Set();
    try { sels.forEach(s => (root.querySelectorAll ? root.querySelectorAll(s) : []).forEach(n => nodes.add(n))); } catch (e) { }
    try { (root.querySelectorAll ? root.querySelectorAll('.money') : []).forEach(n => nodes.add(n)); } catch (e) { }
    nodes.forEach(el => {
      try {
        if (!el || el.hasAttribute('data-price-cents')) return;
        const txt = (el.textContent || '').trim();
        if (!txt) return;
        const cents = parsePriceTextToCents(txt);
        el.setAttribute('data-price-cents', String(cents));
        if (!el.dataset.originalPrice) el.dataset.originalPrice = txt;
      } catch (_) { }
    });
  }

  async function fetchRatesFor(valid) {
    const normalized = Array.from(new Set(valid.map(s => normalizeCode(s)).filter(Boolean)));
    const good = normalized.filter(isIso);
    if (!good.length) return null;

    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (raw) {
        const p = JSON.parse(raw);
        if (p && p.timestamp && (Date.now() - p.timestamp) < CACHE_TTL && p.rates) window.currencySwitcher._cachedRates = p.rates;
      }
    } catch (_) { }

    if (window.currencySwitcher._cachedRates) {
      const hasAll = good.every(s => typeof window.currencySwitcher._cachedRates[s] !== 'undefined');
      if (hasAll) return window.currencySwitcher._cachedRates;
    }

    for (let i = 0; i < providers.length; i++) {
      try {
        const out = await providers[i](good);
        if (out && out.rates) {
          const any = good.some(k => typeof out.rates[k] !== 'undefined');
          if (!any) continue;
          window.currencySwitcher._cachedRates = Object.assign({}, window.currencySwitcher._cachedRates || {}, out.rates);
          try { localStorage.setItem(CACHE_KEY, JSON.stringify({ timestamp: Date.now(), rates: window.currencySwitcher._cachedRates })); } catch (_) { }
          if (window.currencySwitcher._lastCurrency && window.currencySwitcher._cachedRates[window.currencySwitcher._lastCurrency]) {
            window.currencySwitcher._lastRate = window.currencySwitcher._cachedRates[window.currencySwitcher._lastCurrency];
          }
          return window.currencySwitcher._cachedRates;
        }
      } catch (_) { }
    }
    return window.currencySwitcher._cachedRates || null;
  }

  function formatWithCustomSymbol(currency, converted, d) {
    // If this currency should be shown as a whole number, round UP and force zero decimals
    if (ROUNDED && ROUNDED[currency]) {
      const ceiled = Math.ceil(Number(converted) || 0);
      const nf = new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      if (CUSTOM_SYMBOLS && CUSTOM_SYMBOLS[currency]) {
        return `${CUSTOM_SYMBOLS[currency]} ${nf.format(ceiled)}`;
      }
      try {
        return nf.format(ceiled) + ` ${currency}`;
      } catch (_) {
        return `${currency} ${ceiled}`;
      }
    }

    // Normal behavior: use provided decimals (d)
    if (CUSTOM_SYMBOLS && CUSTOM_SYMBOLS[currency]) {
      const nf = new Intl.NumberFormat(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
      const formatted = nf.format(Number(Number(converted).toFixed(d)));
      return `${CUSTOM_SYMBOLS[currency]} ${formatted}`;
    } else {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency, minimumFractionDigits: d, maximumFractionDigits: d }).format(converted);
      } catch (_) {
        return `${currency} ${Number(converted).toFixed(d)}`;
      }
    }
  }

  function convertDOM(currency, rate) {
    if (!currency || !rate) return;
    annotateMoney();
    const d = DECIMALS[currency] ?? 2;
    const nodes = Array.from(document.querySelectorAll('[data-price-cents]'));
    nodes.forEach(el => {
      try {
        const raw = el.getAttribute('data-price-cents') || '0';
        let cents = 0;
        for (let i = 0; i < raw.length; i++) { const n = raw.charCodeAt(i) - 48; if (n >= 0 && n <= 9) cents = cents * 10 + n; }
        const base = cents / 100;
        const converted = base * rate;
        el.textContent = formatWithCustomSymbol(currency, converted, d);
        el.style.visibility = '';
      } catch (_) { }
    });
    try {
      window.currencySwitcher._lastCurrency = normalizeCode(currency);
      window.currencySwitcher._lastRate = rate;
    } catch (_) {}
  }

  function convertDOMForRoot(currency, rate, root) {
    if (!currency || !rate || !root) return;
    const d = DECIMALS[currency] ?? 2;
    const nodes = Array.from((root.querySelectorAll ? root.querySelectorAll('[data-price-cents]') : []));
    if (root.matches && root.matches('[data-price-cents]')) nodes.unshift(root);
    nodes.forEach(el => {
      try {
        const raw = el.getAttribute('data-price-cents') || '0';
        let cents = 0;
        for (let i = 0; i < raw.length; i++) { const n = raw.charCodeAt(i) - 48; if (n >= 0 && n <= 9) cents = cents * 10 + n; }
        const base = cents / 100;
        const converted = base * rate;
        el.textContent = formatWithCustomSymbol(currency, converted, d);
        el.style.visibility = '';
      } catch (_) { }
    });
  }

  function hidePriceNodeUntilConverted(node) {
    try {
      if (!node || node.nodeType !== 1) return;
      if (node.matches && node.matches('[data-price-cents]')) {
        node.style.visibility = 'hidden';
      } else {
        const m = node.querySelectorAll ? node.querySelectorAll('[data-price-cents]') : [];
        m.forEach(x => x.style.visibility = 'hidden');
      }
    } catch (_) { }
  }

  function setPill(switcherEl, code, flagSrc) {
    try {
      const pillFlag = switcherEl.querySelector('.cs-flag-img') || switcherEl.querySelector('#currency-current .cs-flag-img');
      const pillCode = switcherEl.querySelector('.cs-code') || switcherEl.querySelector('#currency-current .cs-code');
      if (pillCode && pillCode.textContent !== code) pillCode.textContent = code;
      if (pillFlag) {
        const src = flagSrc || (pillFlag.getAttribute ? pillFlag.getAttribute('src') : null) || FLAG_FALLBACK;
        if (pillFlag.src !== src) {
          pillFlag.src = src;
          pillFlag.onerror = () => { pillFlag.src = FLAG_FALLBACK; };
        }
        try { pillFlag.alt = code; } catch (_) { }
      }
    } catch (_) { }
  }

  function revealSwitcher(switcherEl) {
    try {
      document.documentElement.classList.remove('currency-loading');
      document.documentElement.classList.add('currency-ready');
      if (!switcherEl) switcherEl = document.querySelector('.currency-switcher') || document.querySelector('#currency-switcher');
      if (switcherEl) {
        switcherEl.style.visibility = '';
        switcherEl.style.opacity = '';
        try { switcherEl.style.pointerEvents = 'auto'; } catch (_) {}
      }
    } catch (_) { }
  }

  function revealFallback(switcherEl) {
    try {
      document.documentElement.classList.remove('currency-loading');
      document.documentElement.classList.add('currency-ready', 'currency-fallback');
      if (!switcherEl) switcherEl = document.querySelector('.currency-switcher') || document.querySelector('#currency-switcher');
      if (switcherEl) {
        switcherEl.style.visibility = '';
        switcherEl.style.opacity = '';
        try { switcherEl.style.pointerEvents = 'auto'; } catch (_) {}
      }
    } catch (_) { }
  }

  function closeDropdownSafe(switcher, dropdown, btn, chevron) {
    try {
      const active = document.activeElement;
      if (active && dropdown && dropdown.contains(active)) {
        try {
          if (btn && typeof btn.focus === 'function') btn.focus({ preventScroll: true });
          else active.blur();
        } catch (_) {
          try { active.blur(); } catch (_) { }
        }
      }
      try { if (dropdown && typeof dropdown.inert !== 'undefined') dropdown.inert = true; } catch (_) { }
      if (dropdown) {
        dropdown.style.display = 'none';
        dropdown.style.maxHeight = '';
        dropdown.style.overflow = '';
        dropdown.setAttribute('aria-hidden', 'true');
        dropdown.classList.remove('open');
      }
      if (chevron) {
        try { chevron.style.transform = 'rotate(0deg)'; } catch (_) {}
      }
      if (btn) {
        try { btn.setAttribute('aria-expanded', 'false'); } catch (_) {}
      }
      try { switcher.classList.remove('open'); } catch (_) {}
    } catch (_) { }
  }

  function openDropdownSafe(switcher, dropdown, btn, chevron) {
    try {
      if (dropdown) {
        dropdown.style.display = 'flex';
        dropdown.style.flexDirection = dropdown.style.flexDirection || 'column';
        dropdown.style.maxHeight = dropdown.style.maxHeight || 'none';
        dropdown.style.overflow = dropdown.style.overflow || 'visible';
        dropdown.setAttribute('aria-hidden', 'false');
        dropdown.classList.add('open');
        try { dropdown.inert = false; } catch (_) {}
        try { dropdown.style.zIndex = dropdown.style.zIndex || '100000'; } catch (_) {}
      }
      if (chevron) {
        try { chevron.style.transform = 'rotate(180deg)'; } catch (_) {}
      }
      if (btn) {
        try { btn.setAttribute('aria-expanded', 'true'); } catch (_) {}
      }
      try { switcher.classList.add('open'); } catch (_) {}
      try { switcher.style.pointerEvents = 'auto'; } catch (_) {}
    } catch (_) { }
  }

  async function detectCountry(timeoutMs = 1100) {
    const attempt = async () => {
      try { const r = await fetch('https://ipapi.co/json/', { cache: 'no-cache' }); if (!r.ok) throw r.status; const b = await r.json(); return b?.country ? b.country.toUpperCase() : null; } catch (e) { try { const r2 = await fetch('https://ipwho.is/', { cache: 'no-cache' }); if (!r2.ok) throw r2.status; const b2 = await r2.json(); return b2?.country_code ? b2.country_code.toUpperCase() : null; } catch (_) { return null; } }
    };
    return new Promise(resolve => {
      let done = false;
      attempt().then(c => { if (!done) { done = true; resolve(c); } });
      setTimeout(() => { if (!done) { done = true; resolve(null); } }, timeoutMs);
    });
  }

  async function initSwitcher(switcherEl) {
    const switcher = switcherEl;
    const btn = switcher.querySelector('.currency-current') || switcher.querySelector('#currency-current');
    const dropdown = switcher.querySelector('.currency-dropdown') || switcher.querySelector('#currency-dropdown');
    const chevron = switcher.querySelector('.cs-chevron-img') || null;
    const pillFlag = switcher.querySelector('.cs-flag-img') || null;
    const items = Array.from(switcher.querySelectorAll('.currency-item') || []);

    function updateSelectedTileClass(code) {
      const normalized = code ? code.toUpperCase().trim() : null;
      items.forEach(it => {
        const itCode = (it.dataset.currency || "").toUpperCase().trim();
        if (itCode === normalized) {
          it.classList.add("selected");
          it.setAttribute("aria-pressed", "true");
        } else {
          it.classList.remove("selected");
          it.removeAttribute("aria-pressed");
        }
      });
    }

    if (dropdown) { dropdown.style.display = 'none'; dropdown.setAttribute('aria-hidden', 'true'); try { dropdown.inert = true; } catch(_){} }
    try { switcher.style.pointerEvents = 'none'; } catch(_) {}
    document.documentElement.classList.add('currency-loading');

    items.forEach(it => {
      try {
        const img = it.querySelector('.item-flag-img');
        const src = it.getAttribute('data-flag-src') || '';
        if (img && src && img.src !== src) { img.src = src; img.onerror = () => { img.src = FLAG_FALLBACK; }; }
      } catch (_) { }
    });

    try {
      if (chevron && chevron.style) {
        chevron.style.transition = chevron.style.transition || 'transform .18s ease';
        chevron.style.transform = chevron.style.transform || 'rotate(0deg)';
      }
      if (btn) {
        try { btn.style.touchAction = btn.style.touchAction || 'manipulation'; } catch (_) {}
        const touchHandler = (ev) => {
          if (ev.type === 'touchstart') ev.preventDefault();
          const willOpen = !switcher.classList.contains('open');
          if (willOpen) openDropdownSafe(switcher, dropdown, btn, chevron);
          else closeDropdownSafe(switcher, dropdown, btn, chevron);
        };
        btn.addEventListener('touchstart', touchHandler, { passive: false });
      }
    } catch (_) { }

    let timer = null;
    let isApplying = false;
    const RECENT_APPLY_TTL = 5000;
    let lastApplied = { currency: null, ts: 0 };

    function setLastAppliedCurrencyAndRate(code, rate) {
      try {
        const nc = normalizeCode(code);
        window.currencySwitcher._lastCurrency = nc;
        window.currencySwitcher._lastRate = rate || (window.currencySwitcher._cachedRates ? window.currencySwitcher._cachedRates[nc] : null);
        lastApplied.currency = nc;
        lastApplied.ts = Date.now();
      } catch (_) {}
    }

    let saved = null; try { saved = localStorage.getItem('selectedCurrency'); } catch (_) { }
    let selected = saved ? normalizeCode(saved) : null;

    if (selected && window.currencySwitcher._cachedRates && window.currencySwitcher._cachedRates[selected]) {
      const selItem = items.find(i => normalizeCode(i.dataset.currency) === selected);
      setPill(switcher, selected, selItem ? (selItem.getAttribute('data-flag-src') || FLAG_FALLBACK) : (pillFlag?.src || FLAG_FALLBACK));
      annotateMoney();
      convertDOM(selected, window.currencySwitcher._cachedRates[selected]);
      setLastAppliedCurrencyAndRate(selected, window.currencySwitcher._cachedRates[selected]);
      updateSelectedTileClass(selected);
      revealSwitcher(switcher);
    } else {
      if (!selected) {
        const geoCountry = await detectCountry(1000);
        const map = { 'BH': 'BHD', 'KW': 'KWD', 'SA': 'SAR', 'OM': 'OMR', 'QA': 'QAR', 'AE': 'AED' };
        selected = map[geoCountry] || BASE_CURRENCY;
      }

      const safeDefault = BASE_CURRENCY;
      const selItemSafe = items.find(i => normalizeCode(i.dataset.currency) === safeDefault);
      setPill(switcher, safeDefault, selItemSafe ? (selItemSafe.getAttribute('data-flag-src') || FLAG_FALLBACK) : (pillFlag?.src || FLAG_FALLBACK));
      revealSwitcher(switcher);

      const avail = items.length ? items.map(i => normalizeCode(i.dataset.currency)) : [selected];
      if (!avail.includes(selected)) avail.push(selected);
      const fetched = await fetchRatesFor(avail);

      if (fetched && fetched[selected]) {
        annotateMoney();
        convertDOM(selected, fetched[selected]);
        const selItem2 = items.find(i => normalizeCode(i.dataset.currency) === selected);
        setPill(switcher, selected, selItem2 ? (selItem2.getAttribute('data-flag-src') || FLAG_FALLBACK) : (pillFlag?.src || FLAG_FALLBACK));
        setLastAppliedCurrencyAndRate(selected, fetched[selected]);
        updateSelectedTileClass(selected);
        revealSwitcher(switcher);
      } else {
        revealFallback(switcher);
      }
    }

    if (btn) {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const willOpen = !switcher.classList.contains('open');
        if (willOpen) openDropdownSafe(switcher, dropdown, btn, chevron);
        else closeDropdownSafe(switcher, dropdown, btn, chevron);
      });
      btn.addEventListener('keydown', (ev) => {
        if (ev.key === ' ' || ev.key === 'Enter') {
          ev.preventDefault();
          btn.click();
        }
      });
    }

    document.addEventListener('click', e => {
      if (!switcher.contains(e.target)) {
        closeDropdownSafe(switcher, dropdown, btn, chevron);
      }
    });

    items.forEach(it => {
      it.addEventListener('click', ev => {
        ev.preventDefault();
        const code = normalizeCode(it.dataset.currency);
        closeDropdownSafe(switcher, dropdown, btn, chevron);
        try { localStorage.setItem('selectedCurrency', code); } catch (_) { }
        updateSelectedTileClass(code);
        (async () => {
          const avail = items.length ? items.map(i => normalizeCode(i.dataset.currency)) : [code];
          if (!avail.includes(code)) avail.push(code);
          const r = await fetchRatesFor(avail);
          if (r && r[code]) {
            annotateMoney();
            convertDOM(code, r[code]);
            setLastAppliedCurrencyAndRate(code, r[code]);
            setPill(switcher, code, it.getAttribute('data-flag-src') || FLAG_FALLBACK);
            revealSwitcher(switcher);
          } else {
            setPill(switcher, code, it.getAttribute('data-flag-src') || FLAG_FALLBACK);
            revealSwitcher(switcher);
          }
        })();
      });
    });

    const scheduleReapply = async () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(async () => {
        try {
          const stored = (function () { try { return localStorage.getItem('selectedCurrency'); } catch (_) { return null; } })() || selected || BASE_CURRENCY;
          const normalizedStored = normalizeCode(stored);

          if (isApplying) return;
          if (lastApplied.currency === normalizedStored && (Date.now() - lastApplied.ts) < RECENT_APPLY_TTL) return;

          isApplying = true;

          if (window.currencySwitcher._lastCurrency === normalizedStored && window.currencySwitcher._lastRate) {
            annotateMoney();
            convertDOM(normalizedStored, window.currencySwitcher._lastRate);
            setLastAppliedCurrencyAndRate(normalizedStored, window.currencySwitcher._lastRate);
            updateSelectedTileClass(normalizedStored);
            revealSwitcher(switcher);
            isApplying = false;
            return;
          }

          const avail = items.length ? items.map(i => normalizeCode(i.dataset.currency)) : [normalizedStored];
          if (!avail.includes(normalizedStored)) avail.push(normalizedStored);

          const rates = await fetchRatesFor(avail);
          if (rates && rates[normalizedStored]) {
            annotateMoney();
            convertDOM(normalizedStored, rates[normalizedStored]);
            setLastAppliedCurrencyAndRate(normalizedStored, rates[normalizedStored]);
            updateSelectedTileClass(normalizedStored);
            revealSwitcher(switcher);
          } else {
            revealFallback(switcher);
          }
        } catch (_) {
          revealFallback(switcher);
        } finally {
          isApplying = false;
        }
      }, 200);
    };

    try {
      const mo = new MutationObserver(muts => {
        muts.forEach(m => {
          if (m.addedNodes && m.addedNodes.length) {
            m.addedNodes.forEach(n => {
              try {
                const lastCurrency = window.currencySwitcher._lastCurrency;
                const lastRate = window.currencySwitcher._lastRate;
                if (lastCurrency && lastRate) {
                  annotateMoney(n);
                  convertDOMForRoot(lastCurrency, lastRate, n);
                } else {
                  hidePriceNodeUntilConverted(n);
                }
              } catch (_) {
                hidePriceNodeUntilConverted(n);
              }
            });
          }
        });
        scheduleReapply();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) { }

    ['variant:change', 'product:variant-change', 'variantChange', 'variantChanged'].forEach(ev => {
      document.addEventListener(ev, scheduleReapply, { passive: true });
    });

    window.currencySwitcher.applyCurrency = async (code) => {
      const normalized = normalizeCode(code);
      try { localStorage.setItem('selectedCurrency', normalized); } catch (_) { }
      updateSelectedTileClass(normalized);
      const avail = items.length ? items.map(i => normalizeCode(i.dataset.currency)) : [normalized];
      if (!avail.includes(normalized)) avail.push(normalized);
      const rates = await fetchRatesFor(avail);
      if (rates && rates[normalized]) {
        annotateMoney();
        convertDOM(normalized, rates[normalized]);
        setLastAppliedCurrencyAndRate(normalized, rates[normalized]);
        const sel = items.find(i => normalizeCode(i.dataset.currency) === normalized);
        setPill(switcher, normalized, sel ? (sel.getAttribute('data-flag-src') || FLAG_FALLBACK) : FLAG_FALLBACK);
        revealSwitcher(switcher);
      } else {
        const sel = items.find(i => normalizeCode(i.dataset.currency) === normalized);
        setPill(switcher, normalized, sel ? (sel.getAttribute('data-flag-src') || FLAG_FALLBACK) : FLAG_FALLBACK);
        revealSwitcher(switcher);
      }
      return true;
    };

    window.currencySwitcher.getSelected = () => { try { return localStorage.getItem('selectedCurrency') || selected || BASE_CURRENCY; } catch (_) { return selected || BASE_CURRENCY; } };
    window.currencySwitcher.getRates = () => window.currencySwitcher._cachedRates || null;
    window.currencySwitcher._ready = true;
  }

  // --- Bootstrap: initialize ALL .currency-switcher instances (replaces previous single init)
  (async () => {
    try {
      const findAllSwitchers = () => Array.from(document.querySelectorAll('.currency-switcher') || []);
      const waitForOne = () => new Promise((resolve, reject) => {
        const existing = findAllSwitchers();
        if (existing.length) return resolve(existing);
        const obs = new MutationObserver((m, o) => {
          const found = findAllSwitchers();
          if (found.length) { o.disconnect(); resolve(found); }
        });
        obs.observe(document.documentElement || document.body, { childList: true, subtree: true });
        setTimeout(() => { try{ obs.disconnect(); } catch(_){}; reject(new Error('timeout')); }, 10000);
      });

      const switcherEls = await waitForOne();
      const alreadyInit = new WeakSet();
      const initElementSafely = async (el) => {
        if (!el || alreadyInit.has(el)) return;
        alreadyInit.add(el);
        try { await initSwitcher(el); } catch(_) {}
      };

      for (let el of switcherEls) await initElementSafely(el);

      try {
        const mo = new MutationObserver(muts => {
          muts.forEach(m => {
            if (m.addedNodes && m.addedNodes.length) {
              m.addedNodes.forEach(node => {
                try {
                  if (node.nodeType === 1 && node.classList && node.classList.contains && node.classList.contains('currency-switcher')) {
                    initElementSafely(node);
                  } else if (node.querySelectorAll) {
                    const found = node.querySelectorAll('.currency-switcher');
                    if (found && found.length) Array.from(found).forEach(initElementSafely);
                  }
                } catch(_) {}
              });
            }
          });
        });
        mo.observe(document.body, { childList: true, subtree: true });
      } catch (_) {}
    } catch (e) {
      window.currencySwitcher.applyCurrency = async () => false;
      window.currencySwitcher.getSelected = () => null;
      window.currencySwitcher.getRates = () => null;
      window.currencySwitcher._ready = false;
      document.documentElement.classList.remove('currency-loading');
      document.documentElement.classList.add('currency-ready','currency-fallback');
      const el = document.querySelector('.currency-switcher') || document.querySelector('#currency-switcher');
      if (el) try { el.style.visibility=''; el.style.pointerEvents='auto'; } catch(_) {}
    }
  })();

})();
